import { createContext, useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

// Create context object and make available through custom hook
const UtilsContext = createContext();
export const useUtils = () => useContext(UtilsContext)

const UtilsProvider = ({ children }) => {

  /**
   * 
   * @param {*} param0 
   * @returns 
   */

  // Alert snackbar severity options
  const alertSeverityTypes = {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success",
  }

  // Alert snackbar state
  const [ alertMessage, setAlertMessage ] = useState('');
  const [ alertSeverity, setAlertSeverity ] = useState(alertSeverityTypes.info);

  function createAlert(message, severity) {
    // Set values to trigger display of alert component
    setAlertMessage(message);
    setAlertSeverity(severity);
  };


  // Form control and input change handling
  const [formState, setFormState] = useState({});
  const [ formError, setFormError ] = useState(null);

  // Explicitly reset form state
  function resetFormState() {
    setFormState({});
    setFormError(null);
  }

  // Form input handling
  function onChange(e) {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
    setFormError(null);
  }

  // Class name joining for Tailwind state mutation
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  // Capitalise all words in a string
  const capitaliseWords = (str) => {
    const capitalisedWordsArray = str.toLowerCase().split(" ").map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalisedWordsArray.join(" ");
  };

  const [ publicIpAddress, setPublicIpAddress ] = useState("");
  
  useEffect(() => {
    // Get user public ip on application load
    getPublicIpAddress();
  }, []);

  // Get user IP address
  async function getPublicIpAddress() {
    const url = `https://api.ipify.org/?format=json&callback=getIP`;
    let requestOptions = {
      method: 'GET',
    }
    console.info("get public ip address request: ", { url, requestOptions });
    await fetch(`${url}`, requestOptions)
      .then(res => res.json())
      .then(data => {
        console.log("get public ip address response: ", data);
        setPublicIpAddress(data.ip);
      })
      .catch(error => {
        console.log(`Error in get public ip address: ${error}`);
        setPublicIpAddress("");
      })
  };

  const contextValue = {
    alertMessage,
    setAlertMessage,
    alertSeverity,
    setAlertSeverity,
    alertSeverityTypes,
    createAlert,
    formState,
    setFormState,
    resetFormState,
    onChange,
    formError,
    setFormError,
    classNames,
    capitaliseWords,
    uuidv4,
    publicIpAddress,
  }

  return (
    <UtilsContext.Provider value={ contextValue }>
      {children}
    </UtilsContext.Provider>
  );
}

export default UtilsProvider;